/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import "../../../styles/enterprise-client/ec-login.css";
// import "../../../styles/enterprise-client/ec-landing-page.css";
// import "../../../styles/enterprise-client/ec-landing-responsive.css";
// import LandingPageFooter from "../../../../common/components/landing-page-footer";
import { Box } from '@mui/material';
// import CommonLandingPageAppBar from '../../../../common/components/common-landing-page-appbar';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import ECLoginForm from './ec-login-form';
import ECLandingSec1 from '../ec-landing-sec1';
import ECLandingSections from '../ec-landing-sections';
import CommonLandingPageAppBar from '../../common/common-landing-page-appbar';
// import ECLandingSections from '../ec-landing-sections';
// import ECLandingSec1 from '../ec-landing-sec1';
// import ECLandingSections from '../ec-landing-sections';

function ECLoginPage() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <CommonLandingPageAppBar
                    handleDrawerToggle={handleDrawerToggle}
                    mobileOpen={mobileOpen}
                    setMobileOpen={setMobileOpen} />
            </Box>
            <div className="ec-landing-page">
            <section className="flex pl-16 pr-16 xl:pt-paddingTop gap-4 bg-bgColor">
            <ECLandingSec1 />
                    <ECLoginForm />
                </section>
                <ECLandingSections />
                {/* <LandingPageFooter /> */}
            </div >
        </>
    )
}

export default ECLoginPage
